import React from 'react';
import VelocityChart from './VelocityChart';

export function Velocity({ sprints, units }) {
  return (
    <>
      <VelocityChart data={sprints} units={units} />
    </>
  );
}

export default Velocity;
